export var GAMES = {
  '7poker': {
    key: '7poker',
    name: '7포커',
    ssn: 156,
    gameInfoSrl: 1,
    msn: 2
  },
  lowbaduki: {
    key: 'lowbaduki',
    name: '로우바둑이',
    ssn: 156,
    gameInfoSrl: 2,
    msn: 2
  },
  highlow: {
    key: 'highlow',
    name: '하이로우',
    ssn: 156,
    gameInfoSrl: 3,
    msn: 2
  },
  newpoker: {
    key: 'newpoker',
    name: '뉴포커',
    ssn: 156,
    gameInfoSrl: 4,
    msn: 2
  },
  hoola: {
    key: 'hoola',
    name: '훌라',
    ssn: 156,
    gameInfoSrl: 5,
    msn: 2
  },
  sudda: {
    key: 'sudda',
    name: '섯다',
    ssn: 179,
    gameInfoSrl: 1,
    msn: 2
  }
};

export var LINKS = {
  closeWebview: 'npsusl://onWebviewClose',

  /** 피망캐쉬 충전 */
  rechargePmangCashPrefix: '//board.pmang.com',

  /** 1:1 문의 */
  oneToOneInquiry: '//helpdesk.pmang.com/inquiry/oneToOneInquiry.do',

  /** 보안 SMS 해지 */
  unregisterSecureSms: '//board.pmang.com/help_top.nwz?cat1=7_5_3',

  /** 개인암호 */
  changePersonalPassword: '//board.pmang.com/help_top.nwz?cat1=7_7_3',
  unregisterPersonalPassword: '//board.pmang.com/help_top.nwz?cat1=7_7_4',

  /** 피망캐쉬 선물하기 */
  pmangCashPresent: '//board.pmang.com/pmang_webgame_purchase.nwz',

  /** 마이피망 > 계좌정보 */
  myPayment: '//www.pmang.com/my_point_info.nwz'
};

export var FCM = {
  firebaseConfig: {
    apiKey: 'AIzaSyDhJ0ebmQQZKPxN4W5riBUrrNB0085Ai24',
    authDomain: 'web-board-push.firebaseapp.com',
    projectId: 'web-board-push',
    storageBucket: 'web-board-push.appspot.com',
    messagingSenderId: '46046713521',
    appId: '1:46046713521:web:f4b283cd780befb0b23490',
    measurementId: 'G-B25V2LH93C'
  },
  fcmOptions: {
    firebaseVapidKey:
      'BNlsPdj672bQc_zDJ_Pi_lYh9Zgt4nVePOqIy2l5TDeR6hnvjzuFF-FAKVswY7FnrZACxd67huh7buBFrtWHdyE',

    // 토픽 구독, 해지 API
    apiEndpoint: '/api/fcm',

    // '7poker_fcm' 처럼 게임별로 구분
    storageKeySuffix: 'fcm',

    // 7포커, 섯다에서만 구독. POKER_USERS_LIVE, SUDDA_USERS_LIVE 같은 이름으로 환경별로 토픽 설정
    topicPrefix: {
      '7poker': 'POKER_USERS',
      sudda: 'SUDDA_USERS'
    }
  }
};
